import React from 'react';
import { XCircle } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const pains = [<>
    Te duele ver a tu hijo{' '}
    <span className="text-red-500 font-bold" data-id="element-128">frustrarse</span> cada vez que
    intenta leer.
  </>, <>
    Temes que se <span className="text-red-500 font-bold" data-id="element-129">quede atrás</span> y
    lo comparen con otros niños.
  </>, <>
    No quieres que{' '}
    <span className="text-red-500 font-bold" data-id="element-130">sufra vergüenza</span> al leer en
    público.
  </>, <>
    Te preocupa verlo{' '}
    <span className="text-red-500 font-bold" data-id="element-131">perder la confianza</span> en sí
    mismo.
  </>];
export function PainPointsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="pt-12 pb-8 px-4 bg-[#FFF5F5]" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <div ref={ref} className={`w-full ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center" data-id="element-135">
            Este libro es para ti si…
          </h2>

          <div className="space-y-6 max-w-2xl mx-auto" data-id="element-136">
            {pains.map((pain, index) => <div key={index} className="flex items-start gap-4" data-id="element-137">
                <div className="shrink-0 mt-1" data-id="element-138">
                  <XCircle className="w-6 h-6 text-red-400" data-id="element-139" />
                </div>
                <p className="text-lg text-gray-700 font-medium" data-id="element-140">{pain}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}